const module = { name: 'fd-location', exports: {} }; const exports = module.exports;



import { fd_location_alertBox as alertBox } from '@grins/fd-modules/splits/onering-global';



import { fd_location_form_creation as _locationFormCreation } from '@grins/fd-modules/splits/onering-global';



import { fd_location_form_events as _locationFormEvents } from '@grins/fd-modules/splits/onering-global';



import { fd_location_utils as fd_location_utils_getLocation__getLocation_updateLocation__updateLocation_setUserLocationCookie__setUserLocationCookie } from '@grins/fd-modules/splits/onering-global';

const { getLocation: _getLocation, updateLocation: _updateLocation, setUserLocationCookie: _setUserLocationCookie } = fd_location_utils_getLocation__getLocation_updateLocation__updateLocation_setUserLocationCookie__setUserLocationCookie;
function init() {
    alertBox.init();
}
document.addEventListener('DOMContentLoaded', init);
module.exports = {
    getLocation: _getLocation,
    updateLocation: _updateLocation,
    locationFormCreation: _locationFormCreation,
    locationFormEvents: _locationFormEvents,
    setUserLocationCookie: _setUserLocationCookie
};
export default module.exports;